// extracted by mini-css-extract-plugin
export var button = "_a8-0";
export var icon = "_a8-1";